import message from "antd/lib/message"
// import axios from "axios"
import Cookies from "js-cookie"
import { DataTableAction } from "../../../../component/table/action/data_table_action"
import { Tools, axios } from "../../../../config"
import { DiscountLogic } from "../../../../logic/discount_logic"

class WarehousingAction extends DataTableAction {

    async delRow(id) {
        const r = await new DiscountLogic().delData(id);

        if (r.data.statusCode == 200) {
            message.success("终止成功")
        }
    }
    delSelectList({ dispatch, selectList }: { dispatch: any; selectList: any; }) {
        selectList.map(async ({ id }) => {
            const r = await axios({
                method: "GET",
                url: Tools.getApiAddress("shop_delete"),
                params: {
                    shopId: id
                },
                headers: {
                    SYSTOKEN: Cookies.get("token"),'ClientSource':'web'
                },
            })

            if (r.data.statusCode == 200) {
                message.success("删除成功")
            }
        })
    }
    async loadPage({ dispatch, pageIndex, pageSize, search }) {
        this.setLoading({dispatch,loading: true})
        const { activityName, goodsId,shopID,discountType,purposeType } = search;

        const params: any = {
            "pageIndex": pageIndex,
            "pageSize": pageSize,
            "purposeType":purposeType?purposeType:3,
            // purposeType||purposeType!=-1?purposeType:'',
            "activityName":activityName?activityName:'',
            "useMemberClassID":'',
            "activityStartDate":'',
            "activityEndDate":'',
            "discountType":discountType==undefined||discountType==-1?'':discountType,
            "shopID":shopID?shopID:[],
            "disState":'',
            "goodsID":[],
            "orderBy":'',
            "sort":'',

        }
        if(goodsId){
            if(goodsId.indexOf(',')){
                params.goodsID = goodsId.split(',')
            }else{
                params.goodsID.push(goodsId)
            }
        }

        // 档案列表
        const r = await new DiscountLogic().selListByRecord(params);

        if (r.data.statusCode == 200) {
            const dataList = r.data.data.dataSource;
            const list = dataList.map((v, i) => {
                v.key = i + 1;
                v.activityStartDate = v.activityStartDate!=null?v.activityStartDate.slice(0,10):''
                v.activityEndDate = v.activityEndDate!=null?v.activityEndDate.slice(0,10):''
                v.activityStartTime = v.activityStartTime!=null?v.activityStartTime.slice(11,22):''
                v.activityEndTime = v.activityEndTime!=null?v.activityEndTime.slice(11,22):''
                return v;
            })

            this.setPaging({ dispatch, pageIndex, total: r.data.data.totalCount, dataList: list, pageSize });
        }
        this.setLoading({dispatch,loading: false})

    }
    setCondition({ dispatch, key, value }) {
        const params = {
        }
        params[key] = value;

        dispatch({ type: "SetSearch", payload: params })
    }
}
export const warehousingAction = new WarehousingAction();